import _slicedToArray from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _classCallCheck from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";
import "core-js/modules/es.array.sort.js";
import _regeneratorRuntime from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/regenerator";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

import { localize } from '../../../nls.js';
import { Emitter } from '../../../base/common/event.js';
import { basename, extUri } from '../../../base/common/resources.js';
import { dispose as _dispose, DisposableStore } from '../../../base/common/lifecycle.js';
import * as strings from '../../../base/common/strings.js';
import { defaultGenerator } from '../../../base/common/idGenerator.js';
import { Range } from '../../common/core/range.js';
import { ResourceMap } from '../../../base/common/map.js';
import { onUnexpectedError } from '../../../base/common/errors.js';
export var OneReference = /*#__PURE__*/function () {
  function OneReference(isProviderFirst, parent, uri, _range, _rangeCallback) {
    _classCallCheck(this, OneReference);

    this.isProviderFirst = isProviderFirst;
    this.parent = parent;
    this.uri = uri;
    this._range = _range;
    this._rangeCallback = _rangeCallback;
    this.id = defaultGenerator.nextId();
  }

  _createClass(OneReference, [{
    key: "range",
    get: function get() {
      return this._range;
    },
    set: function set(value) {
      this._range = value;

      this._rangeCallback(this);
    }
  }, {
    key: "ariaMessage",
    get: function get() {
      return localize('aria.oneReference', "symbol in {0} on line {1} at column {2}", basename(this.uri), this.range.startLineNumber, this.range.startColumn);
    }
  }]);

  return OneReference;
}();
export var FilePreview = /*#__PURE__*/function () {
  function FilePreview(_modelReference) {
    _classCallCheck(this, FilePreview);

    this._modelReference = _modelReference;
  }

  _createClass(FilePreview, [{
    key: "dispose",
    value: function dispose() {
      this._modelReference.dispose();
    }
  }, {
    key: "preview",
    value: function preview(range) {
      var n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 8;
      var model = this._modelReference.object.textEditorModel;

      if (!model) {
        return undefined;
      }

      var startLineNumber = range.startLineNumber,
          startColumn = range.startColumn,
          endLineNumber = range.endLineNumber,
          endColumn = range.endColumn;
      var word = model.getWordUntilPosition({
        lineNumber: startLineNumber,
        column: startColumn - n
      });
      var beforeRange = new Range(startLineNumber, word.startColumn, startLineNumber, startColumn);
      var afterRange = new Range(endLineNumber, endColumn, endLineNumber, 1073741824
      /* MAX_SAFE_SMALL_INTEGER */
      );
      var before = model.getValueInRange(beforeRange).replace(/^\s+/, '');
      var inside = model.getValueInRange(range);
      var after = model.getValueInRange(afterRange).replace(/\s+$/, '');
      return {
        value: before + inside + after,
        highlight: {
          start: before.length,
          end: before.length + inside.length
        }
      };
    }
  }]);

  return FilePreview;
}();
export var FileReferences = /*#__PURE__*/function () {
  function FileReferences(parent, uri) {
    _classCallCheck(this, FileReferences);

    this.parent = parent;
    this.uri = uri;
    this.children = [];
    this._previews = new ResourceMap();
  }

  _createClass(FileReferences, [{
    key: "dispose",
    value: function dispose() {
      _dispose(this._previews.values());

      this._previews.clear();
    }
  }, {
    key: "getPreview",
    value: function getPreview(child) {
      return this._previews.get(child.uri);
    }
  }, {
    key: "ariaMessage",
    get: function get() {
      var len = this.children.length;

      if (len === 1) {
        return localize('aria.fileReferences.1', "1 symbol in {0}, full path {1}", basename(this.uri), this.uri.fsPath);
      } else {
        return localize('aria.fileReferences.N', "{0} symbols in {1}, full path {2}", len, basename(this.uri), this.uri.fsPath);
      }
    }
  }, {
    key: "resolve",
    value: function resolve(textModelResolverService) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _iterator, _step, child, ref;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(this._previews.size !== 0)) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return", this);

              case 2:
                _iterator = _createForOfIteratorHelper(this.children);
                _context.prev = 3;

                _iterator.s();

              case 5:
                if ((_step = _iterator.n()).done) {
                  _context.next = 21;
                  break;
                }

                child = _step.value;

                if (!this._previews.has(child.uri)) {
                  _context.next = 9;
                  break;
                }

                return _context.abrupt("continue", 19);

              case 9:
                _context.prev = 9;
                _context.next = 12;
                return textModelResolverService.createModelReference(child.uri);

              case 12:
                ref = _context.sent;

                this._previews.set(child.uri, new FilePreview(ref));

                _context.next = 19;
                break;

              case 16:
                _context.prev = 16;
                _context.t0 = _context["catch"](9);
                onUnexpectedError(_context.t0);

              case 19:
                _context.next = 5;
                break;

              case 21:
                _context.next = 26;
                break;

              case 23:
                _context.prev = 23;
                _context.t1 = _context["catch"](3);

                _iterator.e(_context.t1);

              case 26:
                _context.prev = 26;

                _iterator.f();

                return _context.finish(26);

              case 29:
                return _context.abrupt("return", this);

              case 30:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[3, 23, 26, 29], [9, 16]]);
      }));
    }
  }]);

  return FileReferences;
}();
export var ReferencesModel = /*#__PURE__*/function () {
  function ReferencesModel(links, title) {
    var _this = this;

    _classCallCheck(this, ReferencesModel);

    this._disposables = new DisposableStore();
    this.groups = [];
    this.references = [];
    this._onDidChangeReferenceRange = new Emitter();
    this.onDidChangeReferenceRange = this._onDidChangeReferenceRange.event;
    this._links = links;
    this._title = title; // grouping and sorting

    var _links = _slicedToArray(links, 1),
        providersFirst = _links[0];

    links.sort(ReferencesModel._compareReferences);
    var current;

    var _iterator2 = _createForOfIteratorHelper(links),
        _step2;

    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var link = _step2.value;

        if (!current || !extUri.isEqual(current.uri, link.uri, true)) {
          // new group
          current = new FileReferences(this, link.uri);
          this.groups.push(current);
        } // append, check for equality first!


        if (current.children.length === 0 || ReferencesModel._compareReferences(link, current.children[current.children.length - 1]) !== 0) {
          var oneRef = new OneReference(providersFirst === link, current, link.uri, link.targetSelectionRange || link.range, function (ref) {
            return _this._onDidChangeReferenceRange.fire(ref);
          });
          this.references.push(oneRef);
          current.children.push(oneRef);
        }
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  }

  _createClass(ReferencesModel, [{
    key: "dispose",
    value: function dispose() {
      _dispose(this.groups);

      this._disposables.dispose();

      this._onDidChangeReferenceRange.dispose();

      this.groups.length = 0;
    }
  }, {
    key: "clone",
    value: function clone() {
      return new ReferencesModel(this._links, this._title);
    }
  }, {
    key: "title",
    get: function get() {
      return this._title;
    }
  }, {
    key: "isEmpty",
    get: function get() {
      return this.groups.length === 0;
    }
  }, {
    key: "ariaMessage",
    get: function get() {
      if (this.isEmpty) {
        return localize('aria.result.0', "No results found");
      } else if (this.references.length === 1) {
        return localize('aria.result.1', "Found 1 symbol in {0}", this.references[0].uri.fsPath);
      } else if (this.groups.length === 1) {
        return localize('aria.result.n1', "Found {0} symbols in {1}", this.references.length, this.groups[0].uri.fsPath);
      } else {
        return localize('aria.result.nm', "Found {0} symbols in {1} files", this.references.length, this.groups.length);
      }
    }
  }, {
    key: "nextOrPreviousReference",
    value: function nextOrPreviousReference(reference, next) {
      var parent = reference.parent;
      var idx = parent.children.indexOf(reference);
      var childCount = parent.children.length;
      var groupCount = parent.parent.groups.length;

      if (groupCount === 1 || next && idx + 1 < childCount || !next && idx > 0) {
        // cycling within one file
        if (next) {
          idx = (idx + 1) % childCount;
        } else {
          idx = (idx + childCount - 1) % childCount;
        }

        return parent.children[idx];
      }

      idx = parent.parent.groups.indexOf(parent);

      if (next) {
        idx = (idx + 1) % groupCount;
        return parent.parent.groups[idx].children[0];
      } else {
        idx = (idx + groupCount - 1) % groupCount;
        return parent.parent.groups[idx].children[parent.parent.groups[idx].children.length - 1];
      }
    }
  }, {
    key: "nearestReference",
    value: function nearestReference(resource, position) {
      var nearest = this.references.map(function (ref, idx) {
        return {
          idx: idx,
          prefixLen: strings.commonPrefixLength(ref.uri.toString(), resource.toString()),
          offsetDist: Math.abs(ref.range.startLineNumber - position.lineNumber) * 100 + Math.abs(ref.range.startColumn - position.column)
        };
      }).sort(function (a, b) {
        if (a.prefixLen > b.prefixLen) {
          return -1;
        } else if (a.prefixLen < b.prefixLen) {
          return 1;
        } else if (a.offsetDist < b.offsetDist) {
          return -1;
        } else if (a.offsetDist > b.offsetDist) {
          return 1;
        } else {
          return 0;
        }
      })[0];

      if (nearest) {
        return this.references[nearest.idx];
      }

      return undefined;
    }
  }, {
    key: "referenceAt",
    value: function referenceAt(resource, position) {
      var _iterator3 = _createForOfIteratorHelper(this.references),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var ref = _step3.value;

          if (ref.uri.toString() === resource.toString()) {
            if (Range.containsPosition(ref.range, position)) {
              return ref;
            }
          }
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }

      return undefined;
    }
  }, {
    key: "firstReference",
    value: function firstReference() {
      var _iterator4 = _createForOfIteratorHelper(this.references),
          _step4;

      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var ref = _step4.value;

          if (ref.isProviderFirst) {
            return ref;
          }
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }

      return this.references[0];
    }
  }], [{
    key: "_compareReferences",
    value: function _compareReferences(a, b) {
      return extUri.compare(a.uri, b.uri) || Range.compareRangesUsingStarts(a.range, b.range);
    }
  }]);

  return ReferencesModel;
}();